import { useTranslation } from 'react-i18next'

import { copies, RequestSummaryLegend } from '@reveni-io/reveni-ui'

import useCustomCopy from '@/hooks/useCustomCopy/useCustomCopy'

import { exchangeConfig } from '../constants'

const ExchangeMessage = ({ instant }) => {
  const { t, i18n } = useTranslation()
  const { title, defaultCopyKey, customCopyKey } = instant ? exchangeConfig.instant : exchangeConfig.normal
  const customDescription = useCustomCopy(customCopyKey)

  return (
    <RequestSummaryLegend
      title={t(title)}
      description={customDescription || copies[i18n.language].requestSummary[defaultCopyKey]}
      instant={instant}
    />
  )
}

export default ExchangeMessage
